export default __webpack_public_path__ + "static/media/lhcf-5.50cae201.jpeg";